import React from 'react';
import {
  Box,
  List as ChakraList,
  ListItem,
  Text,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';

import RichText from './RichText';

const List = ({ data }) => (
  <SimpleGrid as={ChakraList} columns={1} spacing="9.5vw">
    {data.items.map((li) => (
      <ListItem key={li._key} as="li">
        <HStack as="span" align="center" spacing="1vw">
          <Box as="span" w="5vw" h="5vw" bg="white" borderRadius="100%" />
          <Text as="h3" textStyle="body">
            {li.title}
          </Text>
        </HStack>
        {li.richContent && (
          <Box pl="6vw">
            <RichText data={li.richContent} />
          </Box>
        )}
      </ListItem>
    ))}
  </SimpleGrid>
);

export default List;
